import { CheckboxRadiobuttonDropdown as AntdCheckboxRadiobuttonDropdown } from "@empglabs/backoffice-ui-kit"

export const CheckboxRadiobuttonDropdown = props => {
  return <AntdCheckboxRadiobuttonDropdown {...props} />
}
